import { observer } from 'mobx-react';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';

const useStyles = makeStyles((theme) => ({
  opisLitanije: {
    fontSize: '1.4rem',
    textAlign: 'left',
    listStyle: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    backgroundColor: 'red',
    color: '#555',
    border: '1px solid #ece7e7',
    opisLitanije: {
      fontSize: '1.2rem',
      textAlign: 'left',
      listStyle: 'none',
      color: 'blue',
    },
  },
}));

function MolitvaOsobnogPredanja() {
  const classes = useStyles();
  const { aktivnaZemlja } = storeKrunica;
  const { molitvaPredanja } = aktivnaZemlja;

  // console.log('007=', molitvaPredanja);

  return (
    <Container>
      <ul className={classes.opisLitanije}>
        {molitvaPredanja &&
          molitvaPredanja.map((red, index) => {
            return (
              <li key={index}>
                {red.odlomak && <div style={{ height: 15 }} />}
                {red.naslov && <strong>{red.naslov}</strong>}
                {red.naslov ? ' ' : ''}
                {red.tekst}
                {red.odgovor && (
                  <span>
                    {' '}
                    — <b>{red.odgovor}</b>
                  </span>
                )}
              </li>
            );
          })}
      </ul>
    </Container>
  );
}

export default observer(MolitvaOsobnogPredanja);
